var React = require('react');

function ConversationsPath (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"conversations-path","fill":"none","stroke":"rgb(250,250,240)","strokeWidth":"2","d":"M.37,9.42s210.5-85,271,285,571,370.5,601.37,240.87S765.87,384.42,720.37,485.42s122.5,236,397.5,236c156.67,0,259.79-57.77,319.52-128.93"}));
}

ConversationsPath.defaultProps = {"viewBox":"0 0 1438.16 722.42"};

module.exports = ConversationsPath;

ConversationsPath.default = ConversationsPath;
